import { useTranslation } from "react-i18next";
import { axiosInstance } from "api/axios";
import listService from "api/listService";
import { EMenuFilters } from "dto/EMenuFilters";
import ConfirmModal from "components/ConfirmModal";
import { ENotificationType, notification } from "utils/notification";
import Button from "components/Button";
import EmptyPanel from "components/EmptyPanel";
import Loading from "components/Loading";
import Package from "components/Package";
import AcceptanceFilePreview from "components/AcceptanceFilePreview";
import EngagementApprovalPanel from "components/EngagementApprovalPanel";
import PackageThread from "components/PackageThread";
import PanelsLayout from "components/PanelsLayout";
import SortOrder from "components/SortOrder";
import {
  EOrder,
  ETypeOfOrder,
  IOrderObject,
} from "components/SortOrder/typings";
import KeysContext from "contexts/KeysContext";
import PackagesContext from "contexts/PackagesContext";
import { IAttachment } from "dto/IAttachment";
import { IPackage } from "dto/IPackage";
import useFilterMetaData from "hooks/useFilterMetaData";
import usePDF from "hooks/usePDF";
import { useContext, useEffect, useRef, useState } from "react";
import { useInfiniteQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { PackageList } from "./packageList";
import {
  getAcceptanceReceivedPackages,
  getAcceptanceCcPackages,
} from "modules/acceptanceSignModule/mockData";
import styles from "./styles.module.scss";
import RefreshIcon from "assets/icons/reverse.svg?react";
import FilterIcon from "assets/icons/filter2.svg?react";
import CourtPortalService from "api/CourtPortalService";
import emailService from "api/emailService";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Tooltip,
} from "@mui/material";
import { SignalRContext } from "../../App";
import classNames from "classnames";
import { logger } from "utils/logger";
import useRunOnTabReturn from "hooks/useRunOnTabReturn";
import settingsService from "api/settingsService";
import { IntegrationType } from "dto/Settings/IntegrationType";
import { ItemKind } from "dto/IKindItems";
import EmailConfiguration from "components/EmailConfiguration";
import ContactMessageConfiguration from "components/ContactMessageConfiguration";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import { IKey } from "dto/IKey";
import { useMediaQuery } from "usehooks-ts";
import MenuIcon from "assets/icons/menu2.svg?react";
import ModalsManagerContext from "contexts/ModalsManager";
import AddIcon from "assets/icons/add.svg?react";

const MessagesModule = ({ hideMenu = false }: { hideMenu?: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate: syncPiMutate } = CourtPortalService.useSync();
  const { mutate: syncEmailMutate } = emailService.useSync();
  const { data: integrations, refetch: refetchIntegrations } =
    settingsService.useGetIntegrationSettings();
  const isMobile = useMediaQuery("(max-width: 767px)");

  const [selectedElements, setSelectedElements] = useState<IPackage[]>([]);

  const [canSelect, setCanSelect] = useState(false);
  const [selectMultiple, setSelectMultiple] = useState(false);
  const { filterId, kind, packageId, threadId, threadPackageId, status } =
    useParams();
  const queryParams = new URLSearchParams(location.search);
  const PDFId = queryParams.get("pdf");

  const splittedPDFId = PDFId ? PDFId.split(":") : [];

  const [searchText, setSearchText] = useState("");

  const [debouncedText] = useDebounce(searchText, 300);

  const isIncoming = status === "incoming";

  const separatorRef = useRef<HTMLDivElement>(null);

  const [showSomething] = useState(true);
  const [showConfigModal, setShowConfigModal] = useState(false);

  const { packages, setPackages } = useContext(PackagesContext);
  const { keys, setKeys } = useContext(KeysContext);
  const [page, setPage] = useState(0);

  const { listId, listName, itemKinds } = useFilterMetaData({
    filterId: filterId!,
  });

  // Aktywny statyczny filtr "Kosz" (przychodzące/wychodzące) — pokazuje przycisk opróżniania.
  const isTrashFilter =
    filterId?.toLowerCase() ===
      EMenuFilters.RemovedIncomingId.toLowerCase() ||
    filterId?.toLowerCase() === EMenuFilters.RemovedOutgoingId.toLowerCase();
  const [showEmptyTrash, setShowEmptyTrash] = useState(false);
  const { mutate: emptyTrash } = listService.useEmptyTrash();

  const [listFilter, setListFilter] = useState<IOrderObject>({
    type: ETypeOfOrder.SEND_DATE,
    order: EOrder.DESCENDING,
    initalized: false,
  });

  const [statusId, setStatusId] = useState<string | null>(null);
  const [tagId, setTagId] = useState<string | null>(null);
  const [kinde, setKind] = useState<number | null>(null);
  const [unread, setUnread] = useState<boolean>(false);

  const [newPackagesCounter, setNewPackagesCounter] = useState<number>(0);
  const { modals, setModals } = useContext(ModalsManagerContext);

  SignalRContext.useSignalREffect(
    "newMessages",
    (message: any) => {
      // jeśli wyświetlamy wyniki wyszukiwania, to nie dodajemy nowych przesyłek do listy
      if (searchText.length) {
        return;
      }

      if (!message.items) return;

      if (!message.items.length) return;

      const a: IPackage[] = message.items
        .filter(
          (x) =>
            (x.kind & itemKinds) !== 0 &&
            x.id &&
            (x.isIncoming == isIncoming ||
              (x.thread?.id &&
                packages.find((p) => p.Thread?.Id === x.thread.id))),
        )
        .map((m) => {
          return {
            isNew: true,
            Id: m.id,
            InternalId: m.InternalId,
            Kind: m.kind,
            Type: m.type,
            TypeId: 0,
            CreationDate: m.creationDate,
            LastModified: m.lastModified,
            SendDate: m.sendDate,
            ReceiveDate: m.receiveDate,
            ReturnDate: m.returnDate,
            Sender: m.sender,
            ReceivedBy: m.receivedBy,
            IsIncoming: m.isIncoming,
            IsForwarded: m.isForwarded,
            HasTasks: m.hasTasks,
            IsHandled: m.isHandled,
            IsDeskActive: m.isDeskActive,
            IsDraft: m.isDraft,
            IsSpam: m.isSpam,
            Unread: m.unread,
            AttachmentsCount: m.AttachmentsCount,
            TasksCount: 0,
            TagsCount: 0,
            TagIds: [],
            Tags: null,
            Tasks: null,
            Shares: null,
            Attachments:
              m.attachments != null
                ? m.attachments.map((a) => ({
                    Id: a.id,
                    Name: a.name,
                    FileName: a.fileName,
                    Label: a.label,
                    ContentType: a.contentType,
                    Format: a.format,
                    Size: a.size,
                    Uri: a.uri,
                    EncryptionKeyId: a.encryptionKeyId,
                    OwnerKind: a.ownerKind,
                    OwnerId: a.ownerId,
                  }))
                : null,
            Receivers:
              m.receivers != null
                ? m.receivers.map((r) => ({
                    Name: r.name,
                    Email: r.email,
                    SendStatus: r.sendStatus,
                    ParcelType: r.ParcelType,
                    Cc: r.cc,
                    Bcc: r.bcc,
                    IsMe: r.isMe,
                  }))
                : null,
            S1: m.s1,
            S2: m.s2,
            S3: m.s3,
            S4: m.s4,
            N1: m.n1,
            N2: m.n2,
            // Kategoria formy doręczenia (widok N3) — do bramkowania akcji
            // per-wiersz (np. „Potwierdź odbiór osobisty" = PersonalPickup).
            DeliveryCategory: m.deliveryCategory,
            EncryptionKeyId: m.encryptionKeyId,
            IsRemoved: false,
            RemovedDate: null,
            ShowInDossier: 0,
            UserId: m.userId,
            Case: m.case
              ? {
                  Id: m.case.id,
                  Client: m.case.client,
                  Signature: m.case.signature,
                  Title: m.case.title,
                }
              : null,
            Thread: m.thread
              ? {
                  Id: m.thread.id,
                  Label: m.thread.label,
                  Count: m.thread.count,
                  UnreadCount: m.thread.unreadCount,
                  LastMessageDirection: m.thread.lastMessageDirection,
                  HasIncomingMessages: m.thread.hasIncomingMessages,
                  HasOutgoingMessages: m.thread.hasOutgoingMessages,
                }
              : null,
            Dossier: null,
            CommentsCount: 0,
            StatusId: m.statusId,
            IsShared: false,
            SenderUserId: null,
            SenderParticipantId: null,
            SenderDetails: m.senderDetails
              ? {
                  Name: m.senderDetails.name,
                  Nip: m.senderDetails.nip,
                  REGON: m.senderDetails.rEGON,
                  KRS: m.senderDetails.kRS,
                  IsInstitution: m.senderDetails.isInstitution,
                  Email: m.senderDetails.email,
                  EDeliveryAddress: m.senderDetails.eDeliveryAddress,
                  //Address: IAddress;
                }
              : null,
          };
        });

      let current = packages;

      a.forEach((m) => {
        if (isIncoming && !m.Thread?.HasIncomingMessages) {
          console.log("Outgoing email, ignoring");
          return;
        }

        const toReplace = current.find((p) => p.Thread?.Id === m.Thread?.Id);

        if (toReplace) {
          if (toReplace.SendDate < m.SendDate) {
            current = current.filter((x) => x.Id !== toReplace.Id);
          } else {
            // podczas jednej synchronizacji przyszły 2 wiadomości - starsza i nowsza
            return;
          }
        }

        let key: keyof IPackage = "CreationDate";

        switch (listFilter.type) {
          case "date":
            key = "SendDate";
            break;
          case "LastModified":
            key = "LastModified";
            break;
          case "CreationDate":
            key = "CreationDate";
            break;
          case "Title":
            key = "S1";
            break;
        }

        current = insertSorted(
          current,
          m,
          key,
          listFilter.order === EOrder.ASCENDING ? "asc" : "desc",
        );

        if (
          toReplace &&
          (toReplace?.Thread?.Count === 1 || !toReplace.Thread?.Count) &&
          m.Thread?.Count > 1
        ) {
          // jeżeli jest zanaczony, to przeładowanie na widok z wątkami
          if (packageId === toReplace.Id && !threadId) {
            const link = status
              ? status
              : isIncoming === true
              ? "incoming"
              : "outcoming";

            if (m.Kind === 256) {
              navigate(
                `/packages/${filterId}/${link}/${m.Kind}/${m.Id}/preview-letter/${m.Id}`,
              );
            } else if (m?.Thread?.Id && m?.Thread?.Count > 1 /*|| isThread*/) {
              navigate(
                `/packages/thread/${filterId}/${link}/${m.Kind}/${m.Thread.Id}/${m.Id}`,
              );
            }
          }
        }
      });

      setPackages(current);
      setNewPackagesCounter(newPackagesCounter + a.length);

      const newKeys = message.objectKeys.map(
        (x) =>
          ({
            Id: x.id,
            ParentKeyId: x.parentKeyId,
            PrivateKey: x.privateKey,
            PublicKey: x.publicKey,
            EmptyPassphrase: x.emptyPassphrase,
            Armored: x.armored,
          } as IKey),
      );

      setKeys([...keys, newKeys]);
    },
    [],
  );

  function insertSorted<T extends IPackage>(
    array: T[],
    newItem: T,
    key: keyof T,
    order: "asc" | "desc" = "asc",
  ): T[] {
    const compare = (a: T, b: T): number => {
      const aVal = a[key];
      const bVal = b[key];

      let result = 0;

      if (aVal instanceof Date && bVal instanceof Date) {
        result = aVal.getTime() - bVal.getTime();
      } else if (typeof aVal === "string" && typeof bVal === "string") {
        result = aVal.localeCompare(bVal);
      } else {
        throw new Error(
          `Unsupported comparison type for key: ${key.toString()}`,
        );
      }

      return order === "asc" ? result : -result;
    };

    const index = array.findIndex((item) => compare(newItem, item) < 0);

    if (index === -1) {
      return [...array, newItem]; // Insert at the end
    }

    return [...array.slice(0, index), newItem, ...array.slice(index)];
  }

  const handleRefresh = () => {
    syncPiMutate({});
    syncEmailMutate({});
  };

  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    isLoading,
    isFetchingNextPage,
    isFetchingPreviousPage,
    refetch,
    status: stat,
    isFetching,
  } = useInfiniteQuery(
    [
      "packages",
      filterId,
      debouncedText,
      listFilter,
      statusId,
      tagId,
      kinde,
      unread,
    ],
    async ({ pageParam = "" }) => {
      // Korzeń „Akceptacja i Podpis" (Otrzymane / Powiadomienia) — dane z BE.
      if (filterId === "as-received" || filterId === "as-cc") {
        const items =
          filterId === "as-received"
            ? await getAcceptanceReceivedPackages()
            : await getAcceptanceCcPackages();
        return {
          Items: items,
          ObjectKeys: [],
          LastPage: true,
          PageToken: null,
          PrevPageToken: null,
        };
      }

      const query = new URLSearchParams(window.location.search);
      if (searchText.length) {
        query.append("Text", debouncedText);
      }

      if (status !== "pisma") {
        //@ts-ignore
        if (filterId! !== "sending") {
          query.append("IsIncoming", isIncoming.toString());
          query.append("Group", "true");

          if (kinde !== null && kinde !== -1) {
            query.append("Kind", kinde.toString());
          } else {
            //@ts-ignore
            query.append("FilterId", filterId);
          }
          query.append("PageToken", pageParam);
          query.append("SortProp", listFilter.type);
          query.append("SortOrder", listFilter.order);
        } else {
          query.append("PageToken", pageParam);
          query.append("Group", "true");
          query.append("IsIncoming", "false");
          query.append("SortProp", listFilter.type);
          query.append("SortOrder", listFilter.order);
        }
      } else {
        query.append("Group", "true");
        query.append("IsIncoming", "false");
        query.append("PageToken", pageParam);
        query.append("SortProp", listFilter.type);
        query.append("SortOrder", listFilter.order);
        query.append("Kind", "256");
      }

      if (statusId) {
        query.append("StatusId", statusId);
      }

      if (unread) {
        query.append("Unread", "true");
      }

      if (tagId) {
        query.append("TagId", tagId);
      }

      if (packageId && pageParam === "" && !searchText.length) {
        query.append("PageForId.Id", packageId);
        query.append("PageForId.Kind", kind);
      }

      if (threadPackageId && pageParam === "" && !searchText.length) {
        query.append("PageForId.Id", threadPackageId);
        query.append("PageForId.Kind", kind);
      }

      setPage(page + 1);
      const res = await axiosInstance.get(`/list?${query}`);

      return res.data;
    },
    {
      enabled: true,
      staleTime: 1000 * 3,
      cacheTime: 0,
      refetchOnMount: false,
      getPreviousPageParam: (firstPage) => {
        if (firstPage?.PrevPageToken) {
          return firstPage.PrevPageToken;
        }
        return undefined;
      },
      getNextPageParam: (lastPage) => {
        if (!lastPage.LastPage) {
          return lastPage.PageToken;
        }
        return undefined;
      },
    },
  );

  const [isInitialized, setIsInitialized] = useState(false);

  const compileData = async () => {
    logger.log("compile data called");
    if (!data) {
      logger.log("no data");
      return;
    }

    const packs = await Promise.all(
      data?.pages
        .map((page) => {
          return page.Items;
        })
        .flat(),

      // .sort((left: IPackage, right: IPackage) => {
      //   //@ts-ignore
      //   return right.Unread - left.Unread;
      // })
    );

    const newMap = packs.map((p: IPackage) => {
      const oldPack = packages.find((a) => a.Id === p.Id);

      if (oldPack?.isDelete) {
        p.isDelete = true;
      }

      return p;
    });

    const objectKeys = await Promise.all(
      data?.pages
        .map((page) => {
          return page.ObjectKeys;
        })
        .flat(),
    );

    setPackages(newMap.flat());
    // @ts-ignore
    setKeys((prev) => [...prev, ...objectKeys]);
    setIsInitialized(true);
  };

  useEffect(() => {
    if (isFetching) return;
    if (isLoading) return;
    logger.log("Data changed", data);
    compileData();
  }, [data, isFetching]);

  // useEffect(() => {
  //   if (!listFilter.initalized) return;
  //   if (!isInitialized) return;

  //   setPackages([]);
  //   refetch();
  // }, [listFilter]);

  useEffect(() => {
    if (isInitialized) {
      setPackages([]);
      setIsInitialized(false);

      refetch();
    }
  }, [debouncedText, statusId, filterId, tagId, kinde, unread]);

  useRunOnTabReturn(() => {
    console.log("runOnTabReturn");
    if (isInitialized) {
      setPackages([]);
      setIsInitialized(false);

      refetch();
    }
  });

  useEffect(() => {
    setUnread(false);
  }, [statusId, filterId]);

  const changeToSelectable = (e: any) => {
    if (e.code === "ControlLeft" || e?.metaKey) {
      setCanSelect(true);
    }

    if (e.code === "ShiftLeft") {
      setCanSelect(true);
      setSelectMultiple(true);
    }
  };

  const changeToNotSelectable = (e: any) => {
    setCanSelect(false);
    setSelectMultiple(false);
  };
  useEffect(() => {
    window.addEventListener("keydown", changeToSelectable);
    window.addEventListener("keyup", changeToNotSelectable);

    return () => {
      window.removeEventListener("keydown", changeToSelectable);
      window.removeEventListener("keyup", changeToNotSelectable);
    };
  }, []);

  const handleChangeSearchBar = (
    text: string,
    statusId: string | null,
    tagId: string | null,
    entityId: string | null,
    kind: number | null,
  ) => {
    setSearchText(text);
    setStatusId(statusId);
    setTagId(tagId);
    setKind(kind);
  };

  const [firstElement, setFirstElement] = useState<IPackage | null>(null);

  useEffect(() => {
    for (const pack of packages) {
      const p = selectedElements.find((p) => p?.Id === pack?.Id);
      if (p) {
        setFirstElement(p);
        return;
      }
    }

    setFirstElement(null);
  }, [selectedElements]);

  useEffect(() => {
    if (packageId && packageId.length > 0 && selectedElements.length === 0) {
      const toSelect = packages.find((x) => x?.Id === packageId);

      if (toSelect) {
        setSelectedElements([toSelect]);
      }
    }

    // z WS przyszedł nowy element z wątku, który wylądował na korzeniu
    if (selectedElements.length === 1 && selectedElements[0].Thread) {
      const p = packages.find((x) => x?.Id === selectedElements[0].Id);

      if (!p) {
        const p2 = packages.find(
          (x) => x?.Thread?.Id === selectedElements[0].Thread.Id,
        );

        if (p2) {
          setSelectedElements([p2]);
        }
      }
    }

    if (selectedElements.find((e) => e.isDelete)) {
      setSelectedElements(selectedElements.filter((e) => !e.isDelete));
    }
  }, [packages]);

  const { download } = usePDF();

  const onDownload = async (
    pack: IPackage,
    attachment: IAttachment,
    key?: any,
  ) => {
    await download(pack.Id, attachment, pack.Kind);

    return;
  };

  const [showVersion] = useState(false);

  useEffect(() => {
    if (
      integrations?.data &&
      !integrations.data.Active.find((x) => x.Type === IntegrationType.Email) &&
      itemKinds === ItemKind.Email
    ) {
      setShowConfigModal(true);
    } else if (
      integrations?.data &&
      !integrations.data.Active.find(
        (x) => x.Type === IntegrationType.ContactForm,
      ) &&
      itemKinds === ItemKind.ContactMessage
    ) {
      setShowConfigModal(true);
    } else {
      setShowConfigModal(false);
    }
  }, [integrations?.data, itemKinds]);

  const wrapperRef = useRef(null);

  const leftPanel = () => {
    if (hideMenu) {
      return (
        <Package
          onDownload={onDownload}
          onPreview={() => {}}
          kind={kind}
          packageId={packageId}
          showVersion={showVersion}
        />
      );
    }

    if (!integrations?.data) {
      return <Loading></Loading>;
    }

    return (
      <div className={styles.wrapper} ref={wrapperRef}>
        <div className={styles.order}>
          <SortOrder
            isLoading={
              isLoading || isFetchingNextPage || isFetchingPreviousPage
            }
            refetch={() => {
              // setPackages([]);
              // refetch();
            }}
            setListFilter={setListFilter}
            type={listFilter.type}
            order={listFilter.order}
          />
          {isTrashFilter && (
            <Button
              className={styles.emptyTrashButton}
              text={t("dossier.emptyTrash")}
              onClick={() => setShowEmptyTrash(true)}
            />
          )}
          {!isMobile && (
            <div className={styles.buttons}>
              <Tooltip
                title={!unread ? t("tooltips.unreadOnly") : t("common.showAll")}
              >
                <div
                  className={classNames(
                    styles.unreadButton,
                    unread ? styles.active : null,
                  )}
                  onClick={() => setUnread(!unread)}
                >
                  <FilterIcon></FilterIcon>
                </div>
              </Tooltip>
              <Tooltip title={t("tooltips.syncIntegrations")}>
                <div className={styles.refreshButton} onClick={handleRefresh}>
                  <RefreshIcon></RefreshIcon>
                </div>
              </Tooltip>
            </div>
          )}
        </div>
        {/* {(isLoading || isFetchingNextPage) && <Loading />} */}

        <PackageList
          status={stat}
          listFilter={listFilter}
          separatorRef={separatorRef}
          handleScroll={() => {}}
          canSelect={canSelect}
          debouncedText={debouncedText}
          firstElement={firstElement}
          isIncoming={isIncoming}
          onDownload={onDownload}
          searchText={searchText}
          selectMultiple={selectMultiple}
          selectedElements={selectedElements}
          setSelectedElements={setSelectedElements}
          showSomething={showSomething}
          isLoading={isLoading || isFetchingNextPage}
          remove={() => {}}
          isInitialized={isInitialized}
          fetchNextPage={fetchNextPage}
          fetchPrevPage={fetchPreviousPage}
          isFirstLoading={isLoading && !isFetchingNextPage}
          newPackagesCounter={newPackagesCounter}
        />

        {showConfigModal && (
          <ModalLayout
            refWrapper={wrapperRef}
            dock={DockPosition.FULLSCREEN_CENTER}
            showBg={true}
            toggle={() => setShowConfigModal(false)}
          >
            <div className={styles.modalWrapper}>
              {integrations?.data &&
                !integrations.data.Active.find(
                  (x) => x.Type === IntegrationType.Email,
                ) &&
                itemKinds === ItemKind.Email && (
                  <EmailConfiguration
                    toggle={() => {
                      setShowConfigModal(false);
                      refetchIntegrations();
                    }}
                  ></EmailConfiguration>
                )}

              {integrations?.data &&
                !integrations.data.Active.find(
                  (x) => x.Type === IntegrationType.ContactForm,
                ) &&
                itemKinds === ItemKind.ContactMessage && (
                  <ContactMessageConfiguration
                    toggle={() => setShowConfigModal(false)}
                  ></ContactMessageConfiguration>
                )}
            </div>
          </ModalLayout>
        )}

        {showEmptyTrash && (
          <ConfirmModal
            title={t("parcelsTrash.confirmTitle")}
            text={t("parcelsTrash.confirmText")}
            acceptLabel={t("dossier.emptyTrash")}
            cancelLabel={t("common.cancel")}
            showDontShowNextTime={false}
            onAccept={() => {
              emptyTrash(undefined, {
                onSuccess: () => {
                  notification({
                    type: ENotificationType.SUCCESS,
                    title: t("parcelsTrash.doneTitle"),
                    text: t("parcelsTrash.doneText"),
                  });
                  refetch();
                  setShowEmptyTrash(false);
                },
                onError: () => {
                  notification({
                    type: ENotificationType.ERROR,
                    title: t("common.error"),
                    text: t("parcelsTrash.error"),
                  });
                  setShowEmptyTrash(false);
                },
              });
            }}
            onCancel={() => setShowEmptyTrash(false)}
          />
        )}

        {isMobile && (
          <>
            <Paper
              sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                borderLeft: "none !important",
                borderRight: "none !important",
                borderBottom: "none !important",
                borderRadius: "0 !important",
              }}
              elevation={3}
            >
              <BottomNavigation
                sx={{
                  bgcolor: "#fdf8fd",
                  //borderTop: "1px solid #c9c5d0",
                }}
                value={() => {
                  if (unread) return 1;

                  return undefined;
                }}
                onChange={(event, newValue) => {
                  if (newValue === 0) {
                    setModals((old) => ({ ...old, menu: true }));
                  }
                  if (newValue === 1) {
                    setUnread(!unread);
                  }
                  if (newValue === 2) {
                    handleRefresh();
                  }
                  //setValue(newValue);
                }}
              >
                <BottomNavigationAction title="Menu" icon={<MenuIcon />} />
                <BottomNavigationAction
                  sx={{
                    bgcolor: unread ? "#e6defe" : undefined,
                  }}
                  title={t("tooltips.showUnread")}
                  icon={<FilterIcon />}
                />
                <BottomNavigationAction
                  title={t("common.refresh")}
                  icon={<RefreshIcon />}
                />

                <BottomNavigationAction
                  title={t("packages.new")}
                  icon={
                    <AddIcon
                      onClick={() => {
                        setModals({ ...modals, createMobile: true });
                      }}
                      className={styles.addIcon}
                    />
                  }
                />
              </BottomNavigation>
            </Paper>
          </>
        )}
      </div>
    );
  };

  const rightPanel = () => {
    // „Akceptacja i Podpis / Otrzymane | Do wiadomości" — panel prawy pokazuje
    // podgląd pliku wybranej pozycji (zamiast widoku przesyłki).
    if (filterId === "as-received" || filterId === "as-cc") {
      const selected =
        selectedElements[0] ?? packages.find((p) => p?.Id === packageId);
      if (!selected) return <EmptyPanel />;
      // Zaangażowanie budżetowe z silnika workflow — metryka + decyzja zamiast podglądu pliku.
      const acceptanceItem = (selected as { AcceptanceItem?: { DocumentType: string; DocumentId: string; Id: string } })
        .AcceptanceItem;
      if (acceptanceItem?.DocumentType === "engagement") {
        return (
          <EngagementApprovalPanel
            engagementId={acceptanceItem.DocumentId}
            itemId={filterId === "as-received" ? acceptanceItem.Id : undefined}
            onDecided={() => refetch()}
          />
        );
      }
      return <AcceptanceFilePreview pkg={selected} />;
    }
    return (
      <>
        {!!kind?.length && !!packageId?.length && (
          <Package
            onDownload={onDownload}
            onPreview={() => {}}
            listId={listId ?? 0}
            listName={listName}
            kind={kind}
            packageId={packageId}
            // showPDF={showPDF}
            // setShowPDF={setShowPDF}
            // loadingPDF={pdfLoading}
            showVersion={showVersion}
            selectedElements={selectedElements}
            setSelectedElements={setSelectedElements}
            isMobile={isMobile}
          />
        )}
        {!!threadId?.length && (
          <PackageThread
            listFilter={listFilter}
            listId={listId ?? 0}
            listName={listName}
            setSelectedElements={setSelectedElements}
            isMobile={isMobile}
          />
        )}
        {!packageId?.length && !threadId?.length && PDFId && (
          <Package
            onDownload={onDownload}
            listId={listId ?? 0}
            listName={listName}
            kind={kind}
            packageId={splittedPDFId[0]}
            // showPDF={showPDF}
            // setShowPDF={setShowPDF}
            // loadingPDF={pdfLoading}
            showVersion={showVersion}
            selectedElements={selectedElements}
            setSelectedElements={setSelectedElements}
          />
        )}
        {!packageId?.length && !threadId?.length && !PDFId && <EmptyPanel />}
      </>
    );
  };
  return (
    <PanelsLayout
      leftClassName={hideMenu ? styles.menu : styles.changeSize}
      onChangeSearch={handleChangeSearchBar}
      title={
        filterId === "as-received"
          ? "Otrzymane do akceptacji/podpisu"
          : filterId === "as-cc"
            ? "Powiadomienia o akceptacjach"
            : undefined
      }
      leftPanel={leftPanel()}
      rightPanel={rightPanel()}
      resize
      defaultLeft={35}
      minLeft={20}
      disableHeader={hideMenu ? true : false}
      allowRightPanelOverflow={true}
      hideRight={showConfigModal}
      isRightActive={!!packageId?.length || !!threadId?.length}
    />
  );
};
export default MessagesModule;
